import 'jquery.scrollto';
import 'magnific-popup'


// Theme
window.theme = {};

// Theme Common Functions
window.theme.fn = {

    getOptions: function(opts) {

        if (typeof(opts) == 'object') {

            return opts;

        } else if (typeof(opts) == 'string') {

            try {
                return JSON.parse(opts.replace(/'/g,'"').replace(';',''));
            } catch(e) {
                return {};
            }

        } else {

            return {};

        }

    }

};


// Popup
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__popup';

    var PluginPopup = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginPopup.defaults = {
        mp: {} // Magnific Popup settings
    };

    PluginPopup.prototype = {

        initialize: function($el, opts) {

            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .events();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend(true, {}, PluginPopup.defaults, opts, {
                wrapper: this.$el
            });

            return this;
        },

        events: function() {
            var self = this;

            // Click Element Action
            this.options.wrapper.on('click', function(e) {
                e.preventDefault();
                $.magnificPopup.open(self.options.mp);
                return false;
            });

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginPopup: PluginPopup
    });

    // jquery plugin
    $.fn.themePluginPopup = function(opts) {
        return this.map(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginPopup($this, opts);
            }

        });
    }

}).apply(this, [ window.theme, jQuery ]);


// Scrollto
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__scrollto';

    var PluginScrollto = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginScrollto.defaults = {
        target: $('max'), // This defines the position to where element must be scrolled.
        duration: 600, // Duration of the animation, default is 0 which makes it instantaneous
        margin: false, // If true, subtracts the margin and border of the target element.
        offset: 0, // Added to the final position, can be a number or an object with left and top
        easing: 'swing', // Name of an easing equation, you must register the easing function: swing
        visibleMobile: false
    };

    PluginScrollto.prototype = {

        initialize: function($el, opts) {

            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .events();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend(true, {}, PluginScrollto.defaults, opts, {
                wrapper: this.$el
            });

            return this;
        },

        events: function() {
            var self = this;

            // Click Element Action
            self.options.wrapper.on('click', function(e) {
                e.preventDefault();
                $(window).scrollTo(self.options.target, {
                    duration: self.options.duration,
                    margin: self.options.margin,
                    offset: self.options.offset,
                    easing: self.options.easing,
                });
                return false;
            });

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginScrollto: PluginScrollto
    });

    // jquery plugin
    $.fn.themePluginScrollto = function(opts) {
        return this.map(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginScrollto($this, opts);
            }

        });
    }

}).apply(this, [ window.theme, jQuery ]);


// Sticky
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__sticky';

    var PluginSticky = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginSticky.defaults = {
        minWidth: 991,
        activeClass: 'sticky-active'
    };

    PluginSticky.prototype = {
        initialize: function($el, opts) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend(true, {}, PluginSticky.defaults, opts, {
                wrapper: this.$el
            });

            return this;
        },

        build: function() {
            if (!($.isFunction($.fn.pin))) {
                return this;
            }

            var self = this,
                $window = $(window);

            self.options.wrapper.pin(self.options);

            $window.afterResize(function() {
                self.options.wrapper.removeAttr('style').removeData('pin');
                self.options.wrapper.pin(self.options);
                $window.trigger('scroll');
            });

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginSticky: PluginSticky
    });

    // jquery plugin
    $.fn.themePluginSticky = function(opts) {
        return this.map(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginSticky($this, opts);
            }

        });
    }

}).apply(this, [ window.theme, jQuery ]);


// Sticky Header
(function(theme, $) {

    theme = theme || {};

    var initialized = false;

    $.extend(theme, {

        StickyHeader: {

            defaults: {
                wrapper: $('#header'),
                headerBody: $('#header .header-body'),
                stickyEnabled: true,
                stickyEnableOnBoxed: true,
                stickyEnableOnMobile: true,
                stickyStartAt: 0,
                stickyStartAtElement: false,
                stickySetTop: 0,
                stickyChangeLogo: false,
                stickyChangeLogoWrapper: true
            },

            initialize: function($wrapper, opts) {
                if (initialized) {
                    return this;
                }

                initialized = true;
                this.$wrapper = ($wrapper || this.defaults.wrapper);

                this
                    .setOptions(opts)
                    .build()
                    .events();

                return this;
            },

            setOptions: function(opts) {
                this.options = $.extend(true, {}, this.defaults, opts, theme.fn.getOptions(this.$wrapper.data('plugin-options')));

                return this;
            },

            build: function() {
                if (!this.options.stickyEnableOnBoxed && $('html').hasClass('boxed') || !this.options.stickyEnabled) {
                    return this;
                }

                var self = this,
                    $html = $('html'),
                    $window = $(window),
                    sideHeader = $html.hasClass('side-header');

                // HTML Classes
                $html.addClass('sticky-header-enabled');

                if (parseInt(self.options.stickySetTop) < 0) {
                    $html.addClass('sticky-header-negative');
                }

                // Set Start At
                if(self.options.stickyStartAtElement) {

                    var $stickyStartAtElement = $(self.options.stickyStartAtElement);

                    $(window).on('scroll resize', function() {
                        self.options.stickyStartAt = $stickyStartAtElement.offset().top;
                    });

                    $(window).trigger('resize');
                }

                // Boxed
                if($html.hasClass('boxed') && (parseInt(self.options.stickyStartAt) == 0) && $window.width() > 991) {
                    self.options.stickyStartAt = 30;
                }

                // Set Wrapper Min-Height
                if( !sideHeader ) {
                    self.options.wrapper.css('min-height', self.options.wrapper.height());
                }

                // Check Sticky Header
                self.checkStickyHeader = function() {
                    if ($window.scrollTop() >= parseInt(self.options.stickyStartAt)) {
                        self.activateStickyHeader();
                    } else {
                        self.deactivateStickyHeader();
                    }
                };

                // Activate Sticky Header
                self.activateStickyHeader = function() {

                    if ($window.width() < 992) {
                        if (!self.options.stickyEnableOnMobile) {
                            self.deactivateStickyHeader();
                            return;
                        }
                    } else {
                        if (sideHeader) {
                            self.deactivateStickyHeader();
                            return;
                        }
                    }

                    $html.addClass('sticky-header-active');

                    self.options.headerBody.css('top', self.options.stickySetTop);

                    if (self.options.stickyChangeLogo) {
                        self.changeLogo(true);
                    }

                    $.event.trigger({
                        type: 'stickyHeader.activate'
                    });
                };

                // Deactivate Sticky Header
                self.deactivateStickyHeader = function() {

                    $html.removeClass('sticky-header-active');

                    self.options.headerBody.css('top', 0);

                    if (self.options.stickyChangeLogo) {
                        self.changeLogo(false);
                    }

                    $.event.trigger({
                        type: 'stickyHeader.deactivate'
                    });
                };

                // Always Sticky
                if (parseInt(self.options.stickyStartAt) <= 0) {
                    self.activateStickyHeader();
                }

                // Notice Top Bar
                if ($('.notice-top-bar').get(0)) {
                    self.options.stickyStartAt = $('.notice-top-bar').outerHeight();
                }

                // Set Logo
                if (self.options.stickyChangeLogo) {

                    var $logoWrapper = self.options.wrapper.find('.header-logo'),
                        $logo = $logoWrapper.find('img'),
                        logoWidth = $logo.attr('width'),
                        logoHeight = $logo.attr('height'),
                        logoSmallTop = parseInt($logo.attr('data-sticky-top') ? $logo.attr('data-sticky-top') : 0),
                        logoSmallWidth = parseInt($logo.attr('data-sticky-width') ? $logo.attr('data-sticky-width') : 'auto'),
                        logoSmallHeight = parseInt($logo.attr('data-sticky-height') ? $logo.attr('data-sticky-height') : 'auto');

                    if (self.options.stickyChangeLogoWrapper) {
                        $logoWrapper.css({
                            'width': $logo.outerWidth(true),
                            'height': $logo.outerHeight(true)
                        });
                    }

                    self.changeLogo = function(activate) {
                        if(activate) {

                            $logo.css({
                                'top': logoSmallTop,
                                'width': logoSmallWidth,
                                'height': logoSmallHeight
                            });

                        } else {

                            $logo.css({
                                'top': 0,
                                'width': logoWidth,
                                'height': logoHeight
                            });

                        }
                    }

                }

                // Side Header
                var headerBodyHeight,
                    flag = false;

                self.checkSideHeader = function() {
                    if($window.width() < 992 && flag == false) {
                        headerBodyHeight = self.options.headerBody.height();
                        flag = true;
                    }

                    if(self.options.stickyStartAt == 0 && sideHeader) {
                        self.options.wrapper.css('min-height', 0);
                    }

                    if(self.options.stickyStartAt > 0 && sideHeader && $window.width() < 992) {
                        self.options.wrapper.css('min-height', headerBodyHeight);
                    }
                }

                return this;
            },

            events: function() {
                var self = this;

                if (!this.options.stickyEnableOnBoxed && $('body').hasClass('boxed') || !this.options.stickyEnabled) {
                    return this;
                }

                if (!self.options.alwaysStickyEnabled) {
                    $(window).on('scroll resize', function() {
                        self.checkStickyHeader();
                    });
                } else {
                    self.activateStickyHeader();
                }

                $(window).on('load resize', function(){
                    self.checkSideHeader();
                });

                return this;
            }

        }

    });

}).apply(this, [window.theme, jQuery]);